import { useEffect, useState } from 'react'

export interface PublicCompany {
    name: string
    phone: string
    email: string
    street: string
    postalCode: string
    city: string
    openingHours: string
    kvk: string
    vatNumber: string
}

let cache: PublicCompany | null = null
let pending: Promise<PublicCompany | null> | null = null

const load = (): Promise<PublicCompany | null> => {
    if (!pending) {
        pending = fetch('/api/public/settings')
            .then(response => (response.ok ? response.json() : null))
            .then(data => {
                cache = data?.company ?? null
                return cache
            })
            .catch(() => {
                pending = null
                return null
            })
    }

    return pending
}

export const usePublicSettings = (): PublicCompany | null => {
    const [company, setCompany] = useState<PublicCompany | null>(null)

    useEffect(() => {
        let active = true

        if (cache) {
            setCompany(cache)
            return
        }

        load().then(result => {
            if (active) setCompany(result)
        })

        return () => {
            active = false
        }
    }, [])

    return company
}
